import React, { useEffect, useState } from 'react';

interface ToastProps {
  message: string;
  type?: 'success' | 'error';
  onClose?: () => void;
  duration?: number;
}

export default function Toast({ message, type = 'success', onClose, duration = 3000 }: ToastProps) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-24 left-1/2 -translate-x-1/2 z-[9999] animate-in slide-in-from-top-4 fade-in duration-300 pointer-events-none">
      <div className={`
        px-6 py-3 rounded-full shadow-[0_8px_30px_rgb(0,0,0,0.12)] border flex items-center gap-2 font-bold
        ${type === 'success' 
          ? 'bg-white/90 backdrop-blur-md border-green-100 text-green-700' 
          : 'bg-white/90 backdrop-blur-md border-red-100 text-red-700'
        }
      `}>
        <span>{type === 'success' ? '🎉' : '🚫'}</span>
        {message}
      </div>
    </div>
  );
}
